import React from 'react';
export default function BasicTabs(_ref, _ref2) {
  var label = _ref.label,
      itemValue = _ref.value,
      startIcon = _ref.startIcon,
      endIcon = _ref.endIcon,
      disabled = _ref.disabled;
  var value = _ref2.value,
      onChange = _ref2.onChange;
  var active = itemValue === value;
  return {
    active: active,
    className: {
      'jmtd-tabs-tab-active': active,
      'jmtd-tabs-tab-disabled': disabled
    },
    onClick: function onClick() {
      if (!disabled) {
        onChange(itemValue);
      }
    },
    children: /*#__PURE__*/React.createElement(React.Fragment, null, startIcon && /*#__PURE__*/React.createElement("div", {
      className: "jmtd-tabs-start-icon"
    }, startIcon), label, endIcon && /*#__PURE__*/React.createElement("div", {
      className: "jmtd-tabs-start-icon"
    }, endIcon))
  };
}